import { ChangeDetectionStrategy, Component, afterNextRender, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { AppIcon } from './shared/components/app-icon/app-icon';
import { PendingToastService } from './core/services/pending-toast.service';
import { RecomputeStatusService } from './core/services/recompute-status.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, Toast, AppIcon],
  templateUrl: './app.html',
})
export class App {
  /** Exposé au gabarit du toast de recalcul (bouton « Rafraîchir la page »). */
  readonly recompute = inject(RecomputeStatusService);

  private readonly router = inject(Router);

  /**
   * Emmène au journal de version depuis son toast, et le referme au passage — le rappel a
   * rempli son office, le laisser ouvert par-dessus l'écran qu'il vient d'ouvrir n'aurait
   * aucun sens. Le signal, lui, ne disparaît pas : la pastille de l'entête et l'entrée du
   * menu d'administration restent marquées tant que le journal n'est pas rempli.
   */
  ouvrirJournal(closeFn: (event: Event) => void, event: Event): void {
    closeFn(event);
    void this.router.navigate(['/admin/versions']);
  }

  constructor() {
    const pendingToast = inject(PendingToastService);
    // Après le 1er rendu (<p-toast> monté & abonné) : émet un éventuel toast mis en attente
    // avant un rechargement (ex. sauvegarde des settings suivie d'un reload).
    afterNextRender(() => pendingToast.flushPending());
  }
}
